<template>
  <div class="gallery mt-2 columns is-mobile is-multiline">
    <div class="column is-4" v-for="img in images" :key="img.id">
      <img @click="getOriginalImage(img.download_url)" :src="img.thumbnail_url" />
      <div class="has-text-grey is-size-7">{{ img.created_on | localize }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Gallery",
  props: {
    images: Array,
  },
  methods: {
    getOriginalImage: function (url) {
      this.api.getDownloadToken(url).then((response) => {
        window.location.href = `${url}?token=${response.data.token}&content-disposition=inline`
      })
    },
  },
}
</script>
